export enum IGNORE_LIST_MODEL_FIELDS {
    ID = '_id',
    NAME = 'name',
    DESCRIPTION = 'description',
    TIMESTAMP = 'timestamp',
    SOURCE_EXTERNAL_ID = 'sourceExternalId',
    SOURCE_ENVIRONMENT_ID = 'sourceEnvironmentId',
    SOURCE_NAME = 'sourceName',
}

export enum IGNORE_LIST_ITEM_FIELDS {
    ID = 'id',
    NAME = 'name',
    DESCRIPTION = 'description',
    EXPIRATION_DATE = 'expirationDate',
    ENTITY_ID = 'entityId',
    ENV_IDS = 'envIds',
    ORG_UNIT_IDS = 'orgUnitIds',
    ENTITY_NAMES = 'entityNames',
}

export enum CommonIgnoreNames {
    name = 'name',
    description = 'description',
    expirationDate = 'expirationDate',
    vulBox = 'vulBox',
}

export enum CommonIgnoreInnerNames {
    envIds = 'envIds',
    orgUnitIds = 'orgUnitIds',
    entityId = 'entityId',
    entityNames = 'entityNames',
    orgUnitsRadioOption = 'orgUnitsRadioOption',
    environmentsRadioOption = 'environmentsRadioOption',
    entityNamesRadioOption = 'entityNamesRadioOption',
    entityIdRadioOption = 'entityIdRadioOption',
    orgEnvRadio = 'orgEnvRadio',
    entityRadio = 'entityRadio',
}

export const RequiredOneOfVulnerableFields: string[] = [
    CommonIgnoreInnerNames.orgUnitIds,
    CommonIgnoreInnerNames.envIds,
    CommonIgnoreInnerNames.entityNames,
    CommonIgnoreInnerNames.entityId,
];
